/**
 * Snowplow Theme tracker (sheisme)
 *
 * 原则：只旁听、不拦截；任意异常不得影响站点点击/导航/加购。
 *
 * 浏览互斥：home_viewed | collection_viewed | product_viewed | content_viewed
 * 列表曝光：product_impressed（商品卡进入视口，含 collection / featured / 搜索弹窗等）
 * 点击：data-track 委托（product_clicked / nav_clicked / section_clicked）
 * 搜索：Theme 上报 search 并写 _kb_search_attribution；加购 / 结账由 Web Pixel 携带该归因
 *
 * 配置：window.SnowplowConfig（snippets/snowplow-tracking.liquid）
 */
(function () {
  'use strict';

  try {
  var cfg = window.SnowplowConfig;
  if (!cfg || !cfg.collector) return;
  // 调试：URL 加 ?sp_debug=1 或本地改 SnowplowConfig.debug
  if (/[?&]sp_debug=1(?:&|$)/.test(window.location.search)) cfg.debug = true;

  function safeCall(fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (err) {
        if (cfg && cfg.debug && typeof console !== 'undefined') {
          console.warn('[SpTracker] swallowed', err);
        }
      }
    };
  }

  // 规范化 collector，避免尾斜杠导致路径异常
  cfg.collector = String(cfg.collector).replace(/\/+$/, '');

  if (!cfg.libUrl) return;

  (function (p, l, o, w, i, n, g) {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
      p.GlobalSnowplowNamespace.push(i);
      p[i] = function () {
        (p[i].q = p[i].q || []).push(arguments);
      };
      p[i].q = p[i].q || [];
      n = l.createElement(o);
      g = l.getElementsByTagName(o)[0];
      n.async = 1;
      n.src = w;
      if (g && g.parentNode) g.parentNode.insertBefore(n, g);
      else (l.head || l.documentElement).appendChild(n);
    }
  })(window, document, 'script', cfg.libUrl, 'snowplow');

  var snowplow = window.snowplow;
  if (typeof snowplow !== 'function') return;

  // 与 Iglu 登记的 vendor 保持一致（可用 SnowplowConfig.schemaVendor 覆盖）
  var SCHEMA_BASE = 'iglu:' + (cfg.schemaVendor || 'com.yourshop');
  var KB_DUID_COOKIE = '_kb_duid';
  var KB_SID_COOKIE = '_kb_sid';
  var KB_VID_COOKIE = '_kb_vid';
  var SEARCH_ATTRIBUTION_COOKIE = '_kb_search_attribution';
  var KB_CART_ATTR_ID = '_kb_attribution_id';
  var KB_CART_ATTR_DUID = '_kb_duid';
  var AD_CLICK_IDS_SCHEMA = SCHEMA_BASE + '/ad_click_ids/jsonschema/1-0-1';
  var MARKETING_ATTRIBUTION_SCHEMA = SCHEMA_BASE + '/marketing_attribution/jsonschema/1-0-0';
  var SEARCH_ATTRIBUTION_SCHEMA = SCHEMA_BASE + '/search_attribution/jsonschema/1-0-1';
  var KB_CART_ATTR_SEARCH = '_kb_search_attribution';
  var MARKETING_ATTRIBUTION_COOKIE = '_kb_marketing_attribution';
  var MAX_COOKIE_VAL = 256;
  var MARKETING_ATTRIBUTION_COOKIE_MAX = 3500;
  var SEARCH_ATTRIBUTION_COOKIE_MAX = 1024;
  var SEARCH_ATTRIBUTION_MAX_AGE_MS = 2 * 60 * 60 * 1000;
  // Theme 脚本不会自动继承 Pixel 的隐私限制；统一通过 Shopify Customer Privacy API 控制。
  // 初始不写 Cookie / 不发事件，直到 API 明确允许，或 API 不可用时按 Shopify 的兼容规则放行。
  var consentResolved = false;
  var analyticsProcessingAllowed = false;
  var marketingProcessingAllowed = false;
  var trackerStarted = false;
  var pendingTracks = [];
  var VERSIONS = {
    home_viewed: '1-0-0',
    collection_viewed: '1-0-1',
    product_viewed: '1-0-1',
    content_viewed: '1-0-0',
    product_clicked: '1-0-2',
    search: '1-0-2',
    product_impressed: '1-0-1',
    nav_clicked: '1-0-1',
    nav_viewed: '1-0-0',
    section_viewed: '1-0-0',
    section_clicked: '1-0-0',
    page_engaged: '1-0-0',
  };

  /* ── Cookie helpers（_kb_duid + 广告点击持久化）─────────────────── */
  function readCookie(name) {
    try {
      var m = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
      );
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function cookieDomainAttr() {
    try {
      var host = location.hostname || '';
      if (!host || host === 'localhost' || /^[\d.]+$/.test(host)) return '';
      // 店铺预览域不要写到 .myshopify.com（会串店）
      if (/\.myshopify\.com$/i.test(host)) return '';
      var parts = host.split('.');
      if (parts.length < 2) return '';
      // 与 discoverRootDomain 对齐：根域共享，避免 www / 裸域切换丢 gclid
      return '; Domain=.' + parts.slice(-2).join('.');
    } catch (e) {
      return '';
    }
  }

  function writeCookie(name, value, maxAgeSec, maxLen) {
    try {
      if (value == null) return;
      var v = String(value);
      var limit = maxLen != null ? maxLen : MAX_COOKIE_VAL;
      if (v.length > limit) v = v.slice(0, limit);
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      var age = maxAgeSec != null ? maxAgeSec : 7776000; // 90 天，对齐常见广告 cookie
      document.cookie =
        name +
        '=' +
        encodeURIComponent(v) +
        '; path=/' +
        cookieDomainAttr() +
        '; max-age=' +
        age +
        '; SameSite=Lax' +
        secure;
    } catch (e) {}
  }

  function writeKbDuid(id) {
    if (!analyticsProcessingAllowed) return;
    writeCookie(KB_DUID_COOKIE, id, 31536000);
  }

  function writeKbSession(sessionId, visitIdx) {
    if (!analyticsProcessingAllowed) return;
    if (sessionId) writeCookie(KB_SID_COOKIE, sessionId, 1800);
    if (visitIdx != null && visitIdx !== '') writeCookie(KB_VID_COOKIE, String(visitIdx), 1800);
  }

  function parseSearchAttribution(raw) {
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      try {
        var decoded = JSON.parse(decodeURIComponent(raw));
        return decoded && typeof decoded === 'object' && !Array.isArray(decoded) ? decoded : null;
      } catch (decodeErr) {
        return null;
      }
    }
  }

  function currentSearchAttribution() {
    var state = parseSearchAttribution(readCookie(SEARCH_ATTRIBUTION_COOKIE));
    if (!state || !state.search_id || !state.query || !state.searched_at) return null;
    var searchedAt = Number(state.searched_at);
    if (!isFinite(searchedAt) || Date.now() - searchedAt > SEARCH_ATTRIBUTION_MAX_AGE_MS) return null;
    return {
      search_id: String(state.search_id).slice(0, 64),
      query: String(state.query).slice(0, 255),
      search_surface: state.search_surface ? String(state.search_surface).slice(0, 64) : null,
      results_count:
        state.results_count != null && isFinite(Number(state.results_count))
          ? Math.max(0, Math.floor(Number(state.results_count)))
          : null,
      searched_at: Math.floor(searchedAt),
      selected_type: state.selected_type ? String(state.selected_type).slice(0, 64) : null,
      selected_id: state.selected_id ? String(state.selected_id).slice(0, 255) : null,
      selected_name: state.selected_name ? String(state.selected_name).slice(0, 255) : null,
    };
  }

  function beginSearch(data) {
    if (!analyticsProcessingAllowed) return null;
    var query = data && data.query != null ? String(data.query).trim().slice(0, 255) : '';
    if (!query) return null;
    var resultsCount = data && data.results_count != null && isFinite(Number(data.results_count))
      ? Math.max(0, Math.floor(Number(data.results_count)))
      : null;
    var state = {
      search_id: uuidv4(),
      query: query,
      search_surface: data && data.search_surface ? String(data.search_surface).slice(0, 64) : 'search',
      results_count: resultsCount,
      searched_at: Date.now(),
      selected_type: data && data.selected_type ? String(data.selected_type).slice(0, 64) : null,
      selected_id: data && data.selected_id ? String(data.selected_id).slice(0, 255) : null,
      selected_name: data && data.selected_name ? String(data.selected_name).slice(0, 255) : null,
    };
    writeCookie(
      SEARCH_ATTRIBUTION_COOKIE,
      JSON.stringify(state),
      Math.ceil(SEARCH_ATTRIBUTION_MAX_AGE_MS / 1000),
      SEARCH_ATTRIBUTION_COOKIE_MAX
    );
    scheduleCartBridge();
    var payload = {
      query: state.query,
      search_id: state.search_id,
      results_count: state.results_count,
      search_surface: state.search_surface,
      action: (data && data.action) || 'results_shown',
      selected_type: state.selected_type,
      selected_id: state.selected_id,
      selected_name: state.selected_name,
    };
    if (data && data.beacon) trackBeacon('search', payload, '1-0-2');
    else track('search', payload, '1-0-2');
    return state;
  }

  function trackSearchSelection(data) {
    return beginSearch({
      query: data && data.query,
      results_count: null,
      search_surface: (data && data.search_surface) || 'search',
      action: 'selection_clicked',
      selected_type: data && data.selected_type,
      selected_id: data && data.selected_id,
      selected_name: data && data.selected_name,
      beacon: true,
    });
  }

  function cartUpdateUrl() {
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return String(root).replace(/\/?$/, '/') + 'cart/update.js';
    } catch (e) {
      return '/cart/update.js';
    }
  }

  var cartBridgeTimer = null;
  var lastCartBridgeSig = '';

  function scheduleCartBridge() {
    if (!analyticsProcessingAllowed) return;
    if (cartBridgeTimer) clearTimeout(cartBridgeTimer);
    cartBridgeTimer = setTimeout(pushCartBridge, 400);
  }

  function pushCartBridge() {
    var attr = parseStoredAttribution(readCookie(MARKETING_ATTRIBUTION_COOKIE));
    var attributionId = attr && attr.attribution_id;
    var duid = readCookie(KB_DUID_COOKIE);
    var searchAttr = currentSearchAttribution();
    var payload = {};
    if (marketingProcessingAllowed && attributionId) payload[KB_CART_ATTR_ID] = String(attributionId);
    if (duid) payload[KB_CART_ATTR_DUID] = String(duid);
    if (searchAttr) payload[KB_CART_ATTR_SEARCH] = JSON.stringify(searchAttr);
    if (!Object.keys(payload).length) return;
    var sig = JSON.stringify(payload);
    if (sig === lastCartBridgeSig) return;
    lastCartBridgeSig = sig;
    try {
      fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: payload }),
      }).catch(function () {});
    } catch (e) {}
  }

  function expireCookie(name) {
    try {
      document.cookie =
        name + '=; path=/' + cookieDomainAttr() + '; max-age=0; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
  }

  function clearMarketingState() {
    [
      MARKETING_ATTRIBUTION_COOKIE,
      '_kb_gclid', '_kb_gclid_ts', '_kb_gbraid', '_kb_wbraid',
      '_kb_fbclid', '_kb_fbclid_ts', '_kb_msclkid', '_kb_msclkid_ts',
      '_kb_ttclid', '_kb_ttclid_ts', '_kb_epik', '_kb_epik_ts',
    ].forEach(expireCookie);
    lastCartBridgeSig = '';
    try {
      fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: { _kb_attribution_id: '' } }),
      }).catch(function () {});
    } catch (e) {}
  }

  function clearAnalyticsState() {
    [KB_DUID_COOKIE, KB_SID_COOKIE, KB_VID_COOKIE].forEach(expireCookie);
  }

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function readSpIdParts() {
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf('_sp_id.') !== 0 && p.indexOf('_sp_id=') !== 0) continue;
      var val = decodeURIComponent(p.substring(p.indexOf('=') + 1));
      return val.split('.');
    }
    return [];
  }

  function readSpDomainUserId() {
    var id = (readSpIdParts()[0] || '').trim();
    return /^[0-9a-f-]{8,}$/i.test(id) ? id : null;
  }

  function readSpSessionId() {
    var sid = (readSpIdParts()[5] || '').trim();
    return /^[0-9a-f-]{8,}$/i.test(sid) ? sid : null;
  }

  function readSpSessionIndex() {
    var vid = (readSpIdParts()[2] || '').trim();
    return /^\d+$/.test(vid) ? vid : null;
  }

  function urlSearchParam(key) {
    try {
      var q = window.location.search || '';
      if (!q || q === '?') return null;
      var parts = q.slice(1).split('&');
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].split('=');
        if (decodeURIComponent(kv[0] || '') === key) {
          return kv.length > 1
            ? decodeURIComponent((kv.slice(1).join('=') || '').replace(/\+/g, ' '))
            : '';
        }
      }
    } catch (e) {}
    return null;
  }

  /** 落地页捕获 gclid/fbclid 等，避免结账页 URL 丢参 */
  function captureAdParamsFromUrl() {
    if (!marketingProcessingAllowed) return;
    var now = String(Date.now());
    var gclid = urlSearchParam('gclid');
    if (gclid) {
      writeCookie('_kb_gclid', gclid);
      writeCookie('_kb_gclid_ts', now);
    }
    var gbraid = urlSearchParam('gbraid');
    if (gbraid) writeCookie('_kb_gbraid', gbraid);
    var wbraid = urlSearchParam('wbraid');
    if (wbraid) writeCookie('_kb_wbraid', wbraid);
    var fbclid = urlSearchParam('fbclid');
    if (fbclid) {
      writeCookie('_kb_fbclid', fbclid);
      writeCookie('_kb_fbclid_ts', now);
    }
    ['msclkid', 'ttclid', 'epik'].forEach(function (key) {
      var value = urlSearchParam(key);
      if (value) {
        writeCookie('_kb_' + key, value);
        writeCookie('_kb_' + key + '_ts', now);
      }
    });
  }

  function parseGclAw(raw) {
    var m = String(raw || '').match(/^GCL\.(\d+)\.(.+)$/);
    if (!m) return null;
    return { clickTsMs: Number(m[1]) * 1000, gclid: m[2] };
  }

  function collectAdClickIds() {
    if (!marketingProcessingAllowed) return null;
    try {
      var fbp = readCookie('_fbp');
      var fbc = readCookie('_fbc');
      var fbclid = readCookie('_kb_fbclid') || urlSearchParam('fbclid');
      if (!fbc && fbclid) {
        var fts = readCookie('_kb_fbclid_ts') || String(Date.now());
        fbc = 'fb.1.' + fts + '.' + fbclid;
      }
      var gclAw = readCookie('_gcl_aw');
      var gclParsed = parseGclAw(gclAw);
      var gclid = readCookie('_kb_gclid') || (gclParsed && gclParsed.gclid) || urlSearchParam('gclid');
      var gclidTsRaw = readCookie('_kb_gclid_ts');
      var gclid_ts = null;
      if (gclidTsRaw && /^\d+$/.test(gclidTsRaw)) gclid_ts = parseInt(gclidTsRaw, 10);
      else if (gclParsed && gclParsed.clickTsMs) gclid_ts = gclParsed.clickTsMs;

      var data = {
        fbp: fbp || null,
        fbc: fbc || null,
        fbclid: fbclid || null,
        gclid: gclid || null,
        gclid_ts: gclid_ts,
        gbraid: readCookie('_kb_gbraid') || urlSearchParam('gbraid') || null,
        wbraid: readCookie('_kb_wbraid') || urlSearchParam('wbraid') || null,
        gcl_au: readCookie('_gcl_au') || null,
        gcl_aw: gclAw || null,
        msclkid: readCookie('_kb_msclkid') || urlSearchParam('msclkid') || null,
        ttclid: readCookie('_kb_ttclid') || urlSearchParam('ttclid') || null,
        epik: readCookie('_kb_epik') || urlSearchParam('epik') || null,
      };
      var has = false;
      Object.keys(data).forEach(function (k) {
        if (data[k] != null && data[k] !== '') has = true;
      });
      return has ? data : null;
    } catch (e) {
      return null;
    }
  }

  /* ── 首次 / 最后非 Direct 广告归因（与 Checkout Pixel 共用 Cookie） ── */
  function parseStoredAttribution(raw) {
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      try {
        var decoded = JSON.parse(decodeURIComponent(raw));
        return decoded && typeof decoded === 'object' && !Array.isArray(decoded) ? decoded : null;
      } catch (decodeError) {
        return null;
      }
    }
  }

  function hostFromUrl(value) {
    if (!value) return null;
    try {
      var withoutScheme = String(value).replace(/^https?:\/\//i, '');
      return withoutScheme.split('/')[0].split(':')[0].toLowerCase() || null;
    } catch (e) {
      return null;
    }
  }

  function isOwnSiteHost(host) {
    if (!host) return false;
    var pageHost = '';
    try {
      pageHost = String(location.hostname || '').toLowerCase();
    } catch (e) {
      return false;
    }
    if (!pageHost) return false;
    if (host === pageHost) return true;
    if (/\.myshopify\.com$/i.test(pageHost)) return host === pageHost;
    var parts = pageHost.split('.');
    if (parts.length < 2) return false;
    var root = parts.slice(-2).join('.');
    return host === root || host.slice(-(root.length + 1)) === '.' + root;
  }

  function searchEngineFromHost(host) {
    if (!host) return null;
    if (/(^|\.)google\./i.test(host)) return 'google';
    if (/(^|\.)bing\.com$/i.test(host)) return 'bing';
    if (/(^|\.)yahoo\./i.test(host)) return 'yahoo';
    if (/(^|\.)duckduckgo\.com$/i.test(host)) return 'duckduckgo';
    if (/(^|\.)baidu\.com$/i.test(host)) return 'baidu';
    if (/(^|\.)yandex\./i.test(host)) return 'yandex';
    return null;
  }

  function sourceForPaidClick() {
    if (urlSearchParam('gclid') || urlSearchParam('gbraid') || urlSearchParam('wbraid')) {
      return { channel: 'google_ads', source: 'google', medium: 'cpc', clickType: 'google' };
    }
    if (urlSearchParam('fbclid')) return { channel: 'meta_ads', source: 'meta', medium: 'paid_social', clickType: 'meta' };
    if (urlSearchParam('msclkid')) return { channel: 'microsoft_ads', source: 'microsoft', medium: 'cpc', clickType: 'msclkid' };
    if (urlSearchParam('ttclid')) return { channel: 'tiktok_ads', source: 'tiktok', medium: 'paid_social', clickType: 'ttclid' };
    if (urlSearchParam('epik')) return { channel: 'pinterest_ads', source: 'pinterest', medium: 'paid_social', clickType: 'epik' };
    return null;
  }

  function channelFromUtm(source, medium) {
    var src = String(source || '').toLowerCase();
    var med = String(medium || '').toLowerCase();
    if (/^(cpc|ppc|paid|paid_social|display|affiliate_paid)$/.test(med)) {
      if (/google/.test(src)) return 'google_ads';
      if (/(facebook|instagram|meta)/.test(src)) return 'meta_ads';
      if (/(bing|microsoft)/.test(src)) return 'microsoft_ads';
      if (/tiktok/.test(src)) return 'tiktok_ads';
      if (/pinterest/.test(src)) return 'pinterest_ads';
      return 'paid_other';
    }
    if (/^(organic|seo)$/.test(med)) return 'organic_search';
    if (/^(email|newsletter)$/.test(med)) return 'email';
    if (/^sms$/.test(med)) return 'sms';
    if (/^(affiliate|influencer)$/.test(med)) return 'affiliate';
    if (/^(referral|partner)$/.test(med)) return 'referral';
    if (/^(social|organic_social)$/.test(med)) return 'organic_social';
    return null;
  }

  function currentTouch() {
    var href = window.location.href || '';
    var referrerDomain = hostFromUrl(document.referrer || '');
    if (isOwnSiteHost(referrerDomain)) referrerDomain = null;
    var campaign = urlSearchParam('utm_campaign');
    var paid = sourceForPaidClick();
    if (paid) {
      paid.campaign = campaign;
      paid.landingUrl = href;
      paid.referrerDomain = referrerDomain;
      paid.isNonDirect = true;
      paid.isPaid = true;
      return paid;
    }
    var source = urlSearchParam('utm_source');
    var medium = urlSearchParam('utm_medium');
    var utmChannel = channelFromUtm(source, medium);
    if (utmChannel) {
      return { channel: utmChannel, source: source, medium: medium, campaign: campaign, landingUrl: href, referrerDomain: referrerDomain, isNonDirect: true, isPaid: /^paid_|_ads$/.test(utmChannel), clickType: null };
    }
    var searchEngine = searchEngineFromHost(referrerDomain);
    if (searchEngine) {
      return { channel: 'organic_search', source: searchEngine, medium: 'organic', campaign: null, landingUrl: href, referrerDomain: referrerDomain, isNonDirect: true, isPaid: false, clickType: null };
    }
    if (referrerDomain) {
      return { channel: 'referral', source: referrerDomain, medium: 'referral', campaign: null, landingUrl: href, referrerDomain: referrerDomain, isNonDirect: true, isPaid: false, clickType: null };
    }
    return { channel: 'direct', source: 'direct', medium: 'none', campaign: null, landingUrl: href, referrerDomain: null, isNonDirect: false, isPaid: false, clickType: null };
  }

  function writeTouch(target, prefix, touch, now) {
    target[prefix + '_channel'] = touch.channel || null;
    target[prefix + '_source'] = touch.source || null;
    target[prefix + '_medium'] = touch.medium || null;
    target[prefix + '_campaign'] = touch.campaign ? String(touch.campaign).slice(0, 255) : null;
    target[prefix + '_landing_url'] = touch.landingUrl ? String(touch.landingUrl).slice(0, 255) : null;
    target[prefix + '_referrer_domain'] = touch.referrerDomain ? String(touch.referrerDomain).slice(0, 255) : null;
    target[prefix + '_touch_tstamp'] = now;
  }

  function resolveMarketingAttribution() {
    if (!marketingProcessingAllowed) return null;
    var existing = parseStoredAttribution(readCookie(MARKETING_ATTRIBUTION_COOKIE)) || {};
    var state = Object.assign({ attribution_id: uuidv4() }, existing);
    if (!state.attribution_id) state.attribution_id = uuidv4();

    var touch = currentTouch();
    var now = Date.now();
    if (!state.first_channel) writeTouch(state, 'first', touch, now);
    if (touch.isNonDirect) writeTouch(state, 'last', touch, now);
    if (touch.isPaid) {
      state.last_paid_channel = touch.channel;
      state.last_paid_click_id_type = touch.clickType;
      state.last_paid_click_tstamp = now;
    }
    writeCookie(
      MARKETING_ATTRIBUTION_COOKIE,
      encodeURIComponent(JSON.stringify(state)),
      7776000,
      MARKETING_ATTRIBUTION_COOKIE_MAX
    );
    scheduleCartBridge();
    return state;
  }

  function startTracker() {
    if (trackerStarted || !analyticsProcessingAllowed) return;
    trackerStarted = true;
    snowplow('newTracker', 'sp', cfg.collector, {
      appId: cfg.appId || 'sheisme',
      discoverRootDomain: true,
      cookieSameSite: 'Lax',
      // 官方 beacon：带齐 duid/session；不支持时自动回退 POST
      eventMethod: 'beacon',
      bufferSize: 1,
      contexts: {
        webPage: true,
        performanceTiming: false,
      },
    });
    if (cfg.customerId) snowplow('setUserId', String(cfg.customerId));
    syncKbIdentityFromSnowplow(0);
  }

  /**
   * 与 Pixel 共用 domain_userid / session（本仓库 snowplow-sp.min.js 无 setDomainUserId）：
   * 必须排在 newTracker 之后、进 Snowplow 命令队列，等 tracker 真正初始化后再写 _kb_duid / _kb_sid。
   * 用官方 getDomainUserId / getDomainSessionId / _sp_id；拿不到时短重试，禁止自建另一套 UUID。
   */
  function syncKbIdentityFromSnowplow(attempt) {
    var n = attempt || 0;
    snowplow(function () {
      var id = null;
      var sid = null;
      var vid = null;
      try {
        if (typeof this.getDomainUserId === 'function') id = this.getDomainUserId();
        if (typeof this.getDomainSessionId === 'function') sid = this.getDomainSessionId();
        if (typeof this.getDomainSessionIndex === 'function') vid = this.getDomainSessionIndex();
      } catch (e) {}
      if (!id) id = readSpDomainUserId();
      if (!sid) sid = readSpSessionId();
      if (vid == null) vid = readSpSessionIndex();
      if (id) {
        writeKbDuid(id);
        if (sid) writeKbSession(sid, vid);
        scheduleCartBridge();
        if (cfg.debug) console.log('[SpTracker] synced identity', id, sid || '');
        return;
      }
      // tracker 首事件前 _sp_id 可能尚未落盘：短重试，绝不 newVisitorId
      if (n < 8) {
        setTimeout(function () {
          syncKbIdentityFromSnowplow(n + 1);
        }, 100 * (n + 1));
      } else if (cfg.debug) {
        console.warn('[SpTracker] _kb_duid sync skipped: no domain_userid yet');
      }
    });
  }
  function truncate(val, max) {
    if (val == null) return val;
    var s = String(val);
    return s.length > max ? s.slice(0, max) : s;
  }

  function clean(obj) {
    var out = {};
    Object.keys(obj || {}).forEach(function (k) {
      var v = obj[k];
      if (v === undefined) return;
      // strip internal autoTrack helpers not in schema
      if (k.charAt(0) === '_') return;
      out[k] = v;
    });
    return out;
  }

  function flushQueue() {
    if (!trackerStarted || !analyticsProcessingAllowed) return;
    try {
      snowplow('flushBuffer');
    } catch (e) {}
  }

  function track(name, data, version) {
    try {
      // 隐私 API 尚在加载时只暂存本页事件；明确拒绝后直接丢弃。
      if (!consentResolved) {
        pendingTracks.push([name, data, version]);
        return;
      }
      if (!analyticsProcessingAllowed || !trackerStarted) return;
      var ver = version || VERSIONS[name];
      // 不允许 data-track 的拼写错误或已废弃事件走默认 schema；否则会进入 bad topic。
      if (!ver) {
        if (cfg.debug) console.warn('[SpTracker] unsupported event ignored', name);
        return;
      }
      var payload = Object.assign(
        {
          page_url: truncate(window.location.href, 255),
          source: 'theme',
        },
        clean(data)
      );
      var evt = {
        event: {
          schema: SCHEMA_BASE + '/' + name + '/jsonschema/' + ver,
          data: payload,
        },
      };
      var adIds = marketingProcessingAllowed ? collectAdClickIds() : null;
      var marketingAttribution = marketingProcessingAllowed ? resolveMarketingAttribution() : null;
      var searchAttribution = currentSearchAttribution();
      evt.context = [];
      if (adIds) evt.context.push({ schema: AD_CLICK_IDS_SCHEMA, data: adIds });
      if (marketingAttribution) evt.context.push({ schema: MARKETING_ATTRIBUTION_SCHEMA, data: marketingAttribution });
      if (searchAttribution) evt.context.push({ schema: SEARCH_ATTRIBUTION_SCHEMA, data: searchAttribution });
      if (!evt.context.length) delete evt.context;
      var sid = readCookie(KB_SID_COOKIE);
      if (sid) writeKbSession(sid, readCookie(KB_VID_COOKIE));
      snowplow('trackSelfDescribingEvent', evt);
      if (cfg.debug) console.log('[SpTracker]', name, payload, adIds || '', marketingAttribution || '');
    } catch (e) {
      if (cfg.debug) console.warn('[SpTracker] track failed', name, e);
    }
  }

  /**
   * 离开页 / 跳转前：走官方 tracker（保留身份），并尝试 flush。
   * 不再手写 sendBeacon 协议（会丢 duid，且 application/json 易触发 CORS 失败）。
   */
  function trackBeacon(name, data, version) {
    track(name, data, version);
    flushQueue();
  }

  /* ── 页面浏览（互斥）─────────────────────────────────────────── */
  if (cfg.home) {
    track('home_viewed', {
      page_title: cfg.home.page_title || cfg.pageTitle || null,
    });
  } else if (cfg.collection) {
    track('collection_viewed', {
      collection_id: cfg.collection.collection_id || null,
      collection_title: cfg.collection.collection_title || null,
      collection_handle: cfg.collection.collection_handle || null,
      item_count: cfg.collection.item_count != null ? Number(cfg.collection.item_count) : null,
      items: Array.isArray(cfg.collection.items) ? cfg.collection.items : [],
    });
  } else if (cfg.product && cfg.product.item_id) {
    var variantTitle = cfg.product.item_variant;
    if (
      variantTitle &&
      ['default', 'title', 'default title', ''].indexOf(String(variantTitle).toLowerCase()) !== -1
    ) {
      variantTitle = null;
    }
    track('product_viewed', {
      items: [
        {
          item_id: String(cfg.product.item_id),
          item_name: cfg.product.item_name || null,
          item_brand: cfg.product.item_brand || null,
          item_category: cfg.product.item_category || null,
          price: cfg.product.price != null ? Number(cfg.product.price) : null,
          currency: cfg.product.currency || cfg.currency || null,
          item_variant: variantTitle,
          variant_id: cfg.product.variant_id ? String(cfg.product.variant_id) : null,
        },
      ],
    });
  } else if (cfg.content) {
    track('content_viewed', {
      page_type: cfg.content.page_type || cfg.pageType || 'content',
      page_title: cfg.content.page_title || cfg.pageTitle || null,
      page_handle: cfg.content.page_handle || null,
    });
  }

  if (cfg.search && cfg.search.query) {
    beginSearch({
      query: cfg.search.query,
      results_count: cfg.search.resultsCount,
      search_surface: 'search_page',
      action: 'results_shown',
    });
  }

  /* ── data-track 点击委托 ─────────────────────────────────────── */
  function collectProps(el) {
    var props = {};
    var raw = el.getAttribute('data-track-props');
    var eventName = el.getAttribute('data-track');
    if (raw) {
      try {
        props = JSON.parse(raw);
      } catch (e) {
        if (cfg.debug) console.warn('[SpTracker] bad data-track-props', raw);
      }
    }
    // 仅 UI 点击事件需要 link_url；product_clicked schema 不允许额外字段
    if (
      !props.link_url &&
      el.getAttribute('href') &&
      (eventName === 'nav_clicked' || eventName === 'cta_clicked' || eventName === 'banner_clicked')
    ) {
      props.link_url = truncate(el.getAttribute('href'), 255);
    }
    if (!props.cta_text && !props.link_text && !props.banner_name) {
      var text = (el.textContent || '').trim().slice(0, 100);
      if (text) {
        if (eventName === 'nav_clicked') props.link_text = text;
        else if (eventName === 'banner_clicked') props.banner_name = text;
        else if (eventName === 'cta_clicked') props.cta_text = text;
      }
    }
    if (!props.page_type && cfg.pageType) props.page_type = cfg.pageType;
    return props;
  }

  function shouldBeacon(el, event) {
    var href = el.getAttribute('href');
    var isLink = el.tagName === 'A' && href && href !== '#' && href.indexOf('javascript:') !== 0;
    var newTab =
      event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1 || el.target === '_blank';
    return isLink && !newTab;
  }

  // 同一次用户手势内，同一 product_clicked 只报一次（图+标题双链防抖）
  var lastClickKey = '';
  var lastClickAt = 0;

  function onClick(event) {
    var searchSelection = event.target.closest('[data-sp-search-selection]');
    if (searchSelection) {
      trackSearchSelection({
        query: searchSelection.getAttribute('data-sp-search-query'),
        search_surface: searchSelection.getAttribute('data-sp-search-surface'),
        selected_type: searchSelection.getAttribute('data-sp-search-selected-type'),
        selected_id: searchSelection.getAttribute('data-sp-search-selected-id'),
        selected_name: searchSelection.getAttribute('data-sp-search-selected-name'),
      });
    }

    var el = event.target.closest('[data-track]');
    if (!el) {
      // 标题链未挂 data-track：点到同卡主图/标题链接时，回退用主图埋点属性
      var card = event.target.closest('color-swatch[data-sp-impress], [data-sp-impress]');
      if (!card) return;
      var a = event.target.closest('a[href]');
      if (!a || !card.contains(a)) return;
      if (a.classList.contains('vendor-link') || a.hasAttribute('data-omit-track')) return;
      if (!(a.classList.contains('card') || a.closest('.card__title'))) return;
      el = card.querySelector('[data-track="product_clicked"][data-track-props]');
      if (!el) return;
    }
    var name = el.getAttribute('data-track');
    if (!name || !VERSIONS[name]) {
      if (cfg.debug) console.warn('[SpTracker] unknown event', name);
      return;
    }
    var props = collectProps(el);
    if (name === 'product_clicked') {
      // schema 禁止额外字段；防御历史 data-track-props / 误注入
      delete props.link_url;
      delete props.link_text;
      var key =
        String(props.item_id || '') +
        '|' +
        String(props.module || '') +
        '|' +
        String(props.position || '');
      var now = Date.now();
      if (key && key === lastClickKey && now - lastClickAt < 400) return;
      lastClickKey = key;
      lastClickAt = now;
    }
    // 统一走官方 tracker（已配置 eventMethod:beacon），保留用户身份
    // 绝不 preventDefault / stopPropagation
    if (shouldBeacon(el, event)) trackBeacon(name, props);
    else track(name, props);
  }

  document.addEventListener('click', safeCall(onClick), true);

  /* ── SEO 菜单：view + click（事件委托，不 preventDefault）───────── */
  function navLinkText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100) || null;
  }

  function navAreaFor(el, root) {
    if (el.closest('.seo-mnav__drawer, .seo-mnav__body')) return 'mobile';
    if (el.closest('.seo-nav__panel')) return 'mega_menu';
    if (el.closest('.seo-nav__desktop, .seo-nav__bar')) return 'header';
    return root && root.contains(el) ? 'header' : 'header';
  }

  function navParentTitle(el) {
    var item = el.closest('.seo-nav__item--parent, .seo-mnav__item--parent');
    if (!item) return null;
    var top =
      item.querySelector(':scope > .seo-nav__link, :scope > .seo-mnav__trigger, :scope > .seo-mnav__link') ||
      item.querySelector('.seo-nav__link, .seo-mnav__trigger');
    if (!top || top === el) return null;
    return navLinkText(top);
  }

  function bindSeoNavTracking() {
    var root = document.querySelector('seo-navigation');
    if (!root || root.getAttribute('data-sp-nav-bound') === '1') return;
    root.setAttribute('data-sp-nav-bound', '1');

    // 顶栏菜单曝光（每页一次）
    track('nav_viewed', {
      nav_area: 'header',
      menu_title: null,
      page_type: cfg.pageType || null,
    });

    // 点击：只旁听，不拦截（父级菜单自己的 preventDefault 逻辑保持原样）
    root.addEventListener(
      'click',
      safeCall(function (event) {
        var a = event.target.closest(
          'a.seo-nav__link, a.seo-nav__sublink, a.seo-nav__col-title, a.seo-nav__promo-card, a.seo-mnav__link, a.seo-mnav__sublink, a.seo-mnav__col-link'
        );
        if (!a || !root.contains(a)) return;
        // 已有 data-track 时交给通用委托，避免双计
        if (a.getAttribute('data-track')) return;

        var href = a.getAttribute('href') || '';
        var area = navAreaFor(a, root);
        var isTop =
          a.classList.contains('seo-nav__link') || a.classList.contains('seo-mnav__link');
        var payload = {
          link_text: navLinkText(a),
          link_url: href && href !== '#' ? truncate(href, 255) : null,
          nav_area: area,
          parent_title: isTop ? null : navParentTitle(a),
          menu_level: isTop ? 1 : 2,
          page_type: cfg.pageType || null,
        };

        if (shouldBeacon(a, event)) trackBeacon('nav_clicked', payload);
        else track('nav_clicked', payload);
      }),
      true
    );

    // 桌面：子面板打开 → nav_viewed(mega_menu)；关闭后可再次计
    var seenPanels = {};
    var panelObserver = new MutationObserver(
      safeCall(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type !== 'attributes' || m.attributeName !== 'class') return;
          var item = m.target;
          if (!item.classList || !item.classList.contains('seo-nav__item--parent')) return;
          var titleEl = item.querySelector('.seo-nav__link');
          var title = titleEl ? navLinkText(titleEl) : null;
          var key = 'mega:' + (title || '').slice(0, 80);
          if (item.classList.contains('is-open')) {
            if (seenPanels[key]) return;
            seenPanels[key] = true;
            track('nav_viewed', {
              nav_area: 'mega_menu',
              menu_title: title,
              page_type: cfg.pageType || null,
            });
          } else {
            delete seenPanels[key];
          }
        });
      })
    );
    root.querySelectorAll('.seo-nav__item--parent').forEach(function (item) {
      panelObserver.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    // 移动：抽屉打开 → nav_viewed(mobile)
    var mobileOpen = false;
    var bodyObserver = new MutationObserver(
      safeCall(function () {
        var open = document.body.classList.contains('seo-mobile-nav-open');
        if (open && !mobileOpen) {
          track('nav_viewed', {
            nav_area: 'mobile',
            menu_title: null,
            page_type: cfg.pageType || null,
          });
        }
        mobileOpen = open;
      })
    );
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeCall(bindSeoNavTracking));
  } else {
    safeCall(bindSeoNavTracking)();
  }

  /* ── 首页楼层：section_viewed + section_clicked ───────────────── */
  /** 从 section id / class / data-sp-section-type 解析楼层类型 */
  function extractSectionType(el, shortId) {
    var marked =
      el.getAttribute('data-sp-section-type') ||
      (function () {
        var n = el.querySelector('[data-sp-section-type]');
        return n ? n.getAttribute('data-sp-section-type') : null;
      })();
    if (marked) return marked;

    var raw = '';
    var m = shortId.match(/__(.+)$/);
    if (m) raw = m[1];

    // 固定前缀优先（避免 UUID/随机后缀干扰）
    var PREFIXES = [
      ['image_banner', 'image_banner'],
      ['featured_collection', 'featured_collection'],
      ['collection_list', 'collection_list'],
      ['background_video', 'background_video'],
      ['featured_navigation', 'featured_navigation'],
      ['color_collection', 'color_collection'],
      ['grid_view', 'grid_view'],
      ['rich_text', 'rich_text'],
      ['newsletter', 'newsletter'],
      ['multicolumn', 'multicolumn'],
      ['slideshow', 'slideshow'],
      ['video', 'video'],
      ['apps', 'apps'],
      ['separator', 'separator'],
    ];
    var i;
    for (i = 0; i < PREFIXES.length; i++) {
      if (raw.indexOf(PREFIXES[i][0]) === 0) return PREFIXES[i][1];
    }

    var childWithClass = el.querySelector('[class]');
    var cls =
      String(el.className || '') +
      ' ' +
      (childWithClass && childWithClass.className ? String(childWithClass.className) : '');
    if (/\bwt-image-banner\b/.test(cls) || el.querySelector('.wt-image-banner, .hero'))
      return 'image_banner';
    if (/\bnewsletter\b|\bwt-newsletter\b/.test(cls) || el.querySelector('.newsletter'))
      return 'newsletter';
    if (/\bwt-grid-box\b/.test(cls) || el.querySelector('.wt-grid-box')) return 'grid_view';
    if (/\bcollection-list-custom\b|\bcolor-collection\b/.test(cls)) return 'color_collection';
    if (/\bcollection-list\b/.test(cls)) return 'collection_list';
    if (/\bbackground-video\b|\bwt__video\b/.test(cls)) return 'background_video';
    if (/\bfeatured-nav|\bwt-featured-nav/.test(cls)) return 'featured_navigation';
    if (el.querySelector('[class*="instafeed"], [id*="instafeed"]')) return 'instagram';
    if (raw.indexOf('apps') === 0) return 'apps';

    if (raw) {
      if (/^\d/.test(raw) || /^[0-9a-f]{8}/i.test(raw)) return 'custom';
      return raw.replace(/_[A-Za-z0-9]{4,8}$/, '') || 'custom';
    }
    return 'custom';
  }

  function parseSectionMeta(el, index) {
    var id = el.id || '';
    var shortId = id.replace(/^shopify-section-/, '');
    var type = extractSectionType(el, shortId);
    var headingEl = el.querySelector(
      'h1, h2, h3, .headline__title, .wt-featured-collection__title, .hero__title, [class*="heading"]'
    );
    var heading = headingEl
      ? (headingEl.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100)
      : null;
    return {
      section_id: truncate(shortId || id, 255),
      section_type: type,
      section_index: index,
      section_heading: heading || null,
    };
  }

  /** 首个 image_banner → home_banner；其余保持 image_banner */
  function refineHomeSectionTypes(metaByEl, nodes) {
    var seenBanner = false;
    nodes.forEach(function (el) {
      var meta = metaByEl.get(el);
      if (!meta) return;
      if (meta.section_type === 'image_banner') {
        if (!seenBanner) {
          meta.section_type = 'home_banner';
          seenBanner = true;
        } else {
          meta.section_type = 'promo_banner';
        }
      }
      if (meta.section_type === 'apps' && el.querySelector('[class*="instafeed"], [id*="instafeed"]')) {
        meta.section_type = 'instagram';
      }
    });
  }

  function isHomeFloorSection(el) {
    if (!el || !el.id) return false;
    var id = el.id;
    if (id.indexOf('announcement') !== -1) return false;
    if (id.indexOf('__header') !== -1 || /sections--.*__header/.test(id)) return false;
    if (id.indexOf('seo_navigation') !== -1 || id.indexOf('seo-navigation') !== -1) return false;
    if (id.indexOf('__footer') !== -1 || /sections--.*__footer/.test(id)) return false;
    if (id.indexOf('separator') !== -1) return false;
    if (id.indexOf('template--') !== -1) return true;
    return false;
  }

  function bindHomeSectionTracking() {
    if (!(cfg.home || cfg.pageType === 'home')) return;
    if (document.documentElement.getAttribute('data-sp-sections-bound') === '1') return;
    document.documentElement.setAttribute('data-sp-sections-bound', '1');

    var nodes = Array.prototype.slice
      .call(document.querySelectorAll('.shopify-section'))
      .filter(isHomeFloorSection);

    if (!nodes.length) return;

    var metaByEl = new WeakMap();
    nodes.forEach(function (el, i) {
      metaByEl.set(el, parseSectionMeta(el, i));
    });
    refineHomeSectionTypes(metaByEl, nodes);

    // View：进入视口 ≥25% 记一次（首屏 home_banner 更容易命中）
    if (typeof IntersectionObserver === 'function') {
      var seen = new WeakSet();
      var io = new IntersectionObserver(
        safeCall(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.25) return;
            var el = entry.target;
            if (seen.has(el)) return;
            seen.add(el);
            var meta = metaByEl.get(el);
            if (!meta) return;
            track('section_viewed', {
              section_id: meta.section_id,
              section_type: meta.section_type,
              section_index: meta.section_index,
              section_heading: meta.section_heading,
              page_type: 'home',
            });
            io.unobserve(el);
          });
        }),
        { threshold: [0.25, 0.4] }
      );
      nodes.forEach(function (el) {
        io.observe(el);
      });
    } else {
      nodes.forEach(function (el) {
        var meta = metaByEl.get(el);
        if (!meta) return;
        track('section_viewed', {
          section_id: meta.section_id,
          section_type: meta.section_type,
          section_index: meta.section_index,
          section_heading: meta.section_heading,
          page_type: 'home',
        });
      });
    }

    document.addEventListener(
      'click',
      safeCall(function (event) {
        var a = event.target.closest('a[href]');
        if (!a) return;
        if (a.getAttribute('data-track') === 'product_clicked') return;
        if (a.getAttribute('data-track') === 'nav_clicked') return;
        if (a.getAttribute('data-track') === 'section_clicked') return;
        // 商品卡标题链无 data-track，但仍会走 product_clicked 回退——避免再打 section_clicked
        if (
          a.closest('color-swatch[data-sp-impress], [data-sp-impress]') &&
          (a.classList.contains('card') || a.closest('.card__title'))
        ) {
          return;
        }

        var section = a.closest('.shopify-section');
        if (!section || !isHomeFloorSection(section)) return;
        var meta = metaByEl.get(section);
        if (!meta) {
          var idx = nodes.indexOf(section);
          meta = parseSectionMeta(section, idx >= 0 ? idx : nodes.length);
          if (meta.section_type === 'image_banner' && meta.section_index === 0) {
            meta.section_type = 'home_banner';
          }
        }

        var href = a.getAttribute('href') || '';
        if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

        var clickTarget = 'other';
        if (a.closest('.card, .card__container, [class*="product-card"]')) clickTarget = 'product';
        else if (
          a.closest(
            '[class*="hero"], [class*="banner"], .wt__video, .background-video, .wt-image-banner'
          )
        )
          clickTarget = 'banner';
        else if (a.matches('a.button, .button, [class*="btn"]') || /button|btn|cta/i.test(a.className))
          clickTarget = 'cta';

        var text = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100) || null;
        var payload = {
          section_id: meta.section_id,
          section_type: meta.section_type,
          section_index: meta.section_index,
          link_text: text,
          link_url: truncate(href, 255),
          click_target: clickTarget,
          page_type: 'home',
        };
        if (shouldBeacon(a, event)) trackBeacon('section_clicked', payload);
        else track('section_clicked', payload);
      }),
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeCall(bindHomeSectionTracking));
  } else {
    safeCall(bindHomeSectionTracking)();
  }

  /* ── 商品列表曝光：product_impressed（进入视口记一次）───────────────
   * collection 页：缓冲后合并为 1 次请求（items[]）
   * 其它页：仍单条上报
   * 隐藏卡（[hidden] / rec 未揭开）不观察；recommendations / search_top_sellers /
   * predictive_search 按 module+item_id 去重。点击 / 集合合并 / 其它 module 不变。
   * 性能：只用 IntersectionObserver，不在扫卡时强制 layout；记过后 unobserve
   */
  var scanProductImpressions = function () {};

  function bindProductImpressions() {
    if (typeof IntersectionObserver !== 'function') return;

    var batchCollection = !!(cfg.collection || cfg.pageType === 'collection');
    var BATCH_SIZE = 12;
    var FLUSH_MS = 600;
    var buffer = [];
    var flushTimer = null;
    var batchMeta = {
      module: null,
      from_collection_id: null,
      from_collection_title: null,
      page_type: cfg.pageType || 'collection',
    };
    var impressedKeys = new Set();

    function toItem(props) {
      return {
        item_id: String(props.item_id),
        item_name: props.item_name || null,
        item_brand: props.item_brand || null,
        item_category: props.item_category || null,
        price: props.price != null ? Number(props.price) : null,
        currency: props.currency || cfg.currency || null,
        image_url: props.image_url || null,
        product_url: props.product_url || null,
        variant_id: props.variant_id ? String(props.variant_id) : null,
        sku: props.sku || null,
        position: props.position != null ? Number(props.position) : null,
      };
    }

    function flushImpressions(useBeacon) {
      if (flushTimer) {
        clearTimeout(flushTimer);
        flushTimer = null;
      }
      if (!buffer.length) return;
      var items = buffer.splice(0, buffer.length);
      var data = {
        page_type: batchMeta.page_type || cfg.pageType || null,
        module: batchMeta.module || null,
        from_collection_id: batchMeta.from_collection_id || null,
        from_collection_title: batchMeta.from_collection_title || null,
        item_count: items.length,
        items: items,
      };
      if (cfg.debug) console.log('[SpTracker] flush product_impressed', items.length, data);
      if (useBeacon) trackBeacon('product_impressed', data);
      else track('product_impressed', data);
    }

    function scheduleFlush() {
      if (flushTimer) return;
      flushTimer = setTimeout(function () {
        flushTimer = null;
        flushImpressions(false);
      }, FLUSH_MS);
    }

    function impressionKey(props) {
      return String(props.module || '') + '\t' + String(props.item_id);
    }

    function emitImpression(props) {
      if (!props || !props.item_id) {
        if (cfg.debug) console.warn('[SpTracker] impress skip, no item_id', props);
        return;
      }
      // 异步换 DOM / clone idle / 连续输入时，同 module+SKU 只记一次（集合页 batch 不受影响）。
      if (
        props.module === 'recommendations' ||
        props.module === 'search_top_sellers' ||
        props.module === 'predictive_search'
      ) {
        var key = impressionKey(props);
        if (impressedKeys.has(key)) return;
        impressedKeys.add(key);
      }
      var item = toItem(props);

      if (!batchCollection) {
        track('product_impressed', {
          page_type: props.page_type || cfg.pageType || null,
          module: props.module || null,
          from_collection_id: props.from_collection_id || null,
          from_collection_title: props.from_collection_title || null,
          item_count: 1,
          items: [item],
        });
        return;
      }

      if (!batchMeta.from_collection_id && props.from_collection_id) {
        batchMeta.from_collection_id = props.from_collection_id;
        batchMeta.from_collection_title = props.from_collection_title || null;
      }
      if (props.module) batchMeta.module = props.module;
      if (props.page_type) batchMeta.page_type = props.page_type;

      buffer.push(item);
      if (buffer.length >= BATCH_SIZE) flushImpressions(false);
      else scheduleFlush();
    }

    function propsFromCard(root) {
      var link =
        (root.querySelector &&
          root.querySelector('[data-track="product_clicked"][data-track-props]')) ||
        null;
      if (
        !link &&
        root.getAttribute &&
        root.getAttribute('data-track') === 'product_clicked'
      ) {
        link = root;
      }
      return link ? collectProps(link) : null;
    }

    var seen = new WeakSet();
    var observed = new WeakSet();

    function isImpressible(el) {
      if (!el || !el.isConnected) return false;
      if (el.hidden) return false;
      if (typeof el.closest === 'function') {
        if (el.closest('[hidden]')) return false;
        var recGrid = el.closest('rec-product-grid');
        if (recGrid && !recGrid.classList.contains('is-filled')) return false;
      }
      return true;
    }

    var io = new IntersectionObserver(
      safeCall(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // 还在 hidden / 未揭开：继续观察，等 reveal() 后再记
          if (!isImpressible(el)) return;
          io.unobserve(el);
          if (seen.has(el)) return;
          seen.add(el);
          emitImpression(propsFromCard(el));
        });
      }),
      { threshold: 0.15, rootMargin: '0px 0px 80px 0px' }
    );

    function defaultScanRoot() {
      if (batchCollection) {
        return (
          document.getElementById('ProductGridContainer') ||
          document.getElementById('product-grid') ||
          document
        );
      }
      return document;
    }

    scanProductImpressions = function (scope) {
      var root = scope || defaultScanRoot();
      if (!root.querySelectorAll) return;
      var nodes = root.querySelectorAll(
        'color-swatch[data-sp-impress], [data-sp-impress], a.wt-products-slider__product__card[data-track="product_clicked"]'
      );
      if (cfg.debug) console.log('[SpTracker] scan impressions', nodes.length);
      Array.prototype.forEach.call(nodes, function (el) {
        if (observed.has(el)) return;
        if (!isImpressible(el)) return;
        observed.add(el);
        io.observe(el);
      });
    };

    scanProductImpressions();
    // 仅 flush 缓冲；不二次全页 getBoundingClientRect
    setTimeout(function () {
      if (batchCollection) flushImpressions(false);
    }, 800);

    document.addEventListener('facets:change', function () {
      flushImpressions(false);
      var grid =
        document.getElementById('ProductGridContainer') ||
        document.getElementById('product-grid') ||
        document;
      setTimeout(function () {
        scanProductImpressions(grid);
      }, 50);
    });

    document.addEventListener('shopify:section:load', function (event) {
      scanProductImpressions(event && event.target ? event.target : document);
    });

    if (batchCollection) {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') flushImpressions(true);
      });
      window.addEventListener(
        'pagehide',
        function () {
          flushImpressions(true);
        },
        { capture: true }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeCall(bindProductImpressions));
  } else {
    safeCall(bindProductImpressions)();
  }

  /* ── 页面可见停留（会话时长）— 暂停：cfg.pageEngagement === true 时再开 ─ */
  if (cfg.pageEngagement) {
    (function bindPageEngagement() {
      var HEARTBEAT_MS = 15000;
      var MIN_FLUSH_SEC = 1;
      var startedAt = Date.now();
      var accumulatedMs = 0;
      var visibleSince = document.visibilityState === 'visible' ? startedAt : null;
      var tick = 0;
      var lastSentSec = 0;
      var flushed = false;

      function engagedMs() {
        var total = accumulatedMs;
        if (visibleSince != null) total += Date.now() - visibleSince;
        return total;
      }

      function engagedSec() {
        return Math.floor(engagedMs() / 1000);
      }

      function payload(reason, includeTick) {
        var data = {
          page_type: cfg.pageType || null,
          page_title: truncate(cfg.pageTitle || document.title || null, 255),
          engaged_sec: engagedSec(),
          reason: reason || null,
        };
        if (includeTick) {
          tick += 1;
          data.tick = tick;
        } else {
          data.tick = null;
        }
        return data;
      }

      function send(reason, useBeacon, includeTick) {
        var sec = engagedSec();
        if (sec < MIN_FLUSH_SEC && reason !== 'heartbeat') return;
        if (sec === lastSentSec && reason === 'heartbeat') return;
        lastSentSec = sec;
        var data = payload(reason, includeTick);
        if (useBeacon) trackBeacon('page_engaged', data);
        else track('page_engaged', data);
      }

      function onHidden() {
        if (visibleSince != null) {
          accumulatedMs += Date.now() - visibleSince;
          visibleSince = null;
        }
      }

      function onVisible() {
        if (visibleSince == null) visibleSince = Date.now();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          onHidden();
          send('hidden', true, false);
        } else {
          onVisible();
        }
      });

      window.addEventListener(
        'pagehide',
        function () {
          if (flushed) return;
          flushed = true;
          onHidden();
          send('pagehide', true, false);
        },
        { capture: true }
      );

      setInterval(function () {
        if (document.visibilityState !== 'visible') return;
        send('heartbeat', false, true);
      }, HEARTBEAT_MS);
    })();
  }

  function flushPendingTracks() {
    var queued = pendingTracks.splice(0, pendingTracks.length);
    queued.forEach(function (entry) {
      track(entry[0], entry[1], entry[2]);
    });
  }

  function setProcessingPermissions(analyticsAllowed, marketingAllowed, saleAllowed) {
    var hadAnalytics = analyticsProcessingAllowed;
    var hadMarketing = marketingProcessingAllowed;
    consentResolved = true;
    analyticsProcessingAllowed = analyticsAllowed === true;
    // 广告归因属于 marketing；若用户选择不共享数据，也不保留广告标识。
    marketingProcessingAllowed =
      analyticsProcessingAllowed && marketingAllowed === true && saleAllowed !== false;

    if (!analyticsProcessingAllowed) {
      pendingTracks = [];
      if (hadAnalytics || readCookie(KB_DUID_COOKIE)) clearAnalyticsState();
      if (hadMarketing || readCookie(MARKETING_ATTRIBUTION_COOKIE)) clearMarketingState();
      return;
    }

    if (!marketingProcessingAllowed && (hadMarketing || readCookie(MARKETING_ATTRIBUTION_COOKIE))) {
      clearMarketingState();
    }

    startTracker();
    if (marketingProcessingAllowed) safeCall(captureAdParamsFromUrl)();
    flushPendingTracks();
  }

  function applyShopifyPrivacy() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      // Shopify API 不可用时遵循其兼容建议：继续处理；上线店铺通常都会加载该 API。
      setProcessingPermissions(true, true, true);
      return;
    }
    try {
      setProcessingPermissions(
        privacy.analyticsProcessingAllowed() === true,
        privacy.marketingAllowed() === true,
        typeof privacy.saleOfDataAllowed === 'function' ? privacy.saleOfDataAllowed() : true
      );
    } catch (e) {
      setProcessingPermissions(true, true, true);
    }
  }

  function initPrivacyControl() {
    var shopify = window.Shopify;
    function onConsentChanged() {
      applyShopifyPrivacy();
    }

    document.addEventListener('visitorConsentCollected', onConsentChanged);
    if (shopify && shopify.customerPrivacy) {
      applyShopifyPrivacy();
      return;
    }
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) setProcessingPermissions(true, true, true);
        else applyShopifyPrivacy();
      });
      return;
    }
    setProcessingPermissions(true, true, true);
  }

  function onSearchDrawerOpen(root) {
    var scope =
      root && root.querySelectorAll ? root : document.querySelector('search-drawer') || document;
    var modules = scope.querySelectorAll('[data-sp-search-module]');
    Array.prototype.forEach.call(modules, function (mod) {
      var type = mod.getAttribute('data-sp-search-module') || '';
      if (!type) return;
      try {
        var style = window.getComputedStyle(mod);
        if (style.display === 'none' || style.visibility === 'hidden') return;
      } catch (e) {}
      var isTopSellers = type === 'top_sellers';
      track('section_viewed', {
        section_id: isTopSellers ? 'search_top_sellers' : 'search_hot_searched',
        section_type: isTopSellers ? 'search_top_sellers' : 'search_hot_searched',
        section_index: isTopSellers ? 1 : 0,
        section_heading: mod.getAttribute('data-sp-search-heading') || null,
        page_type: 'search',
      });
    });
    try {
      scanProductImpressions(scope);
    } catch (e) {}
  }

  window.SpTracker = {
    track: track,
    trackBeacon: trackBeacon,
    beginSearch: beginSearch,
    trackSearchSelection: trackSearchSelection,
    onSearchDrawerOpen: onSearchDrawerOpen,
    scanProductImpressions: function (scope) {
      try {
        scanProductImpressions(scope);
      } catch (e) {}
    },
    config: cfg,
  };
  initPrivacyControl();
  } catch (bootErr) {
    // 启动失败也绝不能影响主题其它脚本
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[SpTracker] boot failed', bootErr);
    }
  }
})();
